/**
 * Primjeri foto-zadataka koje gosti izvlače (QR galerija).
 *
 * Ovo je izlog za sajt i ponudu — pravi spisak od kojeg gosti izvlače živi na
 * servisu galerija (gallery-service/src/challenges.js), jer se tekst zadatka
 * mora potvrditi na serveru prije nego uđe u galeriju.
 */
export const GUEST_CHALLENGE_SAMPLES = [
  'Uslikaj mladence dok se smiju — bez poziranja',
  'Nađi najstarijeg gosta i uslikaj ga sa mladencima',
  'Selfie sa cijelim stolom za kojim sjediš',
  'Uslikaj prvi ples iz svog ugla',
  'Snimi najluđi potez na podijumu',
  'Uslikaj tortu prije nego što je iko takne',
  'Nađi nekoga ko se smije do suza i uslikaj ga',
  'Uslikaj detalj koji većina ne primijeti',
  'Napravi selfie sa mladencima',
  'Uslikaj cipele koje su najviše plesale',
  'Snimi trenutak kad svi dižu ruke uvis',
  'Uslikaj najmlađeg gosta na svadbi',
];

/** Nasumičan zadatak koji nije isti kao trenutni — za "daj drugi". */
export const nextChallengeIndex = (current, total = GUEST_CHALLENGE_SAMPLES.length) => {
  const next = Math.floor(Math.random() * total);
  return next === current ? (next + 1) % total : next;
};
